// extracted by mini-css-extract-plugin
export var addViewLink = "_7-2";
export var availabilityIcon = "_7-17";
export var availabilitySelectionIcon = "_7-16";
export var backButton = "_7-3";
export var backIcon = "_7-10";
export var conversationCount = "_7-4";
export var dragHandle = "_7-6";
export var dropdown = "_7-f";
export var dropdownIcon = "_7-8";
export var dropdownOption = "_7-7";
export var dropdownTriangle = "_7-e";
export var expand = "_7-g";
export var folder = "_7-j";
export var folderItem = "_7-d";
export var icon = "_7-9";
export var iconRow = "_7-a";
export var image = "_7-b";
export var logo = "_7-c";
export var navContainer = "_7-i";
export var navigationFooter = "_7-h";
export var pageShell = "_7-0";
export var pageShellWms = "_7-1";
export var placeholderAvailable = "_7-12";
export var placeholderBox = "_7-15";
export var placeholderBusy = "_7-14";
export var placeholderUnavailable = "_7-13";
export var profile = "_7-l";
export var profileContainer = "_7-n";
export var profileDropdown = "_7-o";
export var profileImage = "_7-m";
export var profileMain = "_7-p";
export var profileSubtitle = "_7-r";
export var profileTitle = "_7-q";
export var reorderIcon = "_7-s";
export var sentLine = "_7-v";
export var settingsHeader = "_7-t";
export var sidenavTextColor = "_7-z";
export var spamLine = "_7-u";
export var subitemWithTag = "_7-5";
export var supportItems = "_7-k";
export var teamText = "_7-11";
export var viewLine = "_7-y";
export var viewLineButton = "_7-x";
export var viewLineButtons = "_7-w";